import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const WalletStatus = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');
  const [balance, setBalance] = useState('0.00');
  const [network, setNetwork] = useState('Ethereum');
  const [isConnecting, setIsConnecting] = useState(false);

  // Simulate wallet connection status
  useEffect(() => {
    const checkWalletConnection = () => {
      // Simulate checking for existing wallet connection
      const savedConnection = localStorage.getItem('wallet_connected');
      if (savedConnection === 'true') {
        setIsConnected(true);
        setWalletAddress('0x742d35Cc6634C0532925a3b8D4C9db96590b5b8c');
        setBalance('2.45');
      }
    };

    checkWalletConnection();
  }, []);

  const handleConnectWallet = async () => {
    setIsConnecting(true);
    
    try {
      // Simulate wallet connection process
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      setIsConnected(true);
      setWalletAddress('0x742d35Cc6634C0532925a3b8D4C9db96590b5b8c');
      setBalance('2.45');
      localStorage.setItem('wallet_connected', 'true');
    } catch (error) {
      console.error('Failed to connect wallet:', error);
    } finally {
      setIsConnecting(false);
    }
  };

  const handleDisconnectWallet = () => {
    setIsConnected(false);
    setWalletAddress('');
    setBalance('0.00');
    localStorage.removeItem('wallet_connected');
  };

  const formatAddress = (address) => {
    if (!address) return '';
    return `${address?.slice(0, 6)}...${address?.slice(-4)}`;
  };

  const getNetworkIcon = () => {
    switch (network) {
      case 'Ethereum':
        return 'Zap';
      case 'Polygon':
        return 'Triangle';
      default:
        return 'Globe';
    }
  };

  if (!isConnected) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={handleConnectWallet}
        loading={isConnecting}
        iconName="Wallet"
        iconPosition="left"
        className="text-sm"
      >
        {isConnecting ? 'Connecting...' : 'Connect Wallet'}
      </Button>
    );
  }

  return (
    <div className="flex items-center space-x-3">
      {/* Network Indicator */}
      <div className="flex items-center space-x-1 px-2 py-1 bg-success/10 text-success rounded-md text-xs font-medium">
        <Icon name={getNetworkIcon()} size={12} />
        <span>{network}</span>
      </div>

      {/* Wallet Info */}
      <div className="flex items-center space-x-2 px-3 py-2 bg-muted rounded-md">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse-subtle" />
          <div className="text-sm">
            <div className="font-mono text-xs text-muted-foreground">
              {formatAddress(walletAddress)}
            </div>
            <div className="font-medium text-xs">
              {balance} ETH
            </div>
          </div>
        </div>
        
        {/* Disconnect Button */}
        <button
          onClick={handleDisconnectWallet}
          className="flex items-center justify-center w-6 h-6 text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded transition-smooth"
          title="Disconnect wallet"
        >
          <Icon name="LogOut" size={14} />
        </button>
      </div>
    </div>
  );
};

export default WalletStatus;